export const addNRPageView = async (pageName) => {
  const callNR = () => {
    try {
      const userAnonymized = window?._Cohesion
        ? window._Cohesion?.anonymousId
        : ''
      /* eslint-disable */
      if (window.newrelic) {
        console.log('NR PageAction', `PageView - ${pageName}`)
        newrelic.addPageAction(`PageView - ${pageName}`, {
          anonymous_id: userAnonymized,
        })
      }
      /* eslint-enable */
    } catch (e) {
      console.error('addNRPageView error-', e)
    }
  }

  if (typeof window !== 'undefined' && window.newrelic && window._Cohesion) {
    return callNR()
  }

  await new Promise((resolve) => {
    setTimeout(() => {
      callNR()
      resolve()
    }, 1500)
  })
}

export const addNRPageAction = async (pageAction, payload = {}) => {
  const callNR = () => {
    try {
      const userAnonymized = window?._Cohesion
        ? window._Cohesion?.anonymousId
        : ''
      /* eslint-disable */
      if (window.newrelic) {
        console.log('NR PageAction', pageAction, payload)
        newrelic.addPageAction(pageAction, {
          ...payload,
          anonymous_id: userAnonymized,
        })
      }
      /* eslint-enable */
    } catch (e) {
      console.error('addNRPageAction error-', e)
    }
  }

  if (typeof window !== 'undefined' && window.newrelic && window._Cohesion) {
    return callNR()
  }

  await new Promise((resolve) => {
    setTimeout(() => {
      callNR()
      resolve()
    }, 1500)
  })
}
